import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import OptionsDropDown from '@CommonFunctionalDisplay/OptionsDropDown';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import { ReactComponent as KaizIQText } from '@Assets/kaiziqText.svg';
import { useReduxLeads } from '@Hooks/reduxLeadsHook/useReduxLeads';
import WhatsappHeader from '@Whatsapp/WhatsappHeader';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import './TopPanel.scss';

function TopPanel() {

    const navigate = useNavigate();
    const location = useLocation();
    const { activeUser } = useReduxActiveUser();
    const className = 'topPanel';

    const handleLogoClick = () => {
        navigate('/home');
    };

    const logOut = () => {
        const userAuthService = new UserAuthService();
        userAuthService.logout();
    };

    if (location?.pathname === '/') {
        return (
            <div className={`${className} flex-row-flex-end-space-between width-wfa`}>
                <div className={`${className}__left flex-row-center-1vw-gap`}>
                    <KaizIQText
                        style={{height: '30px', width: 'max-content'}}
                        className={`${className}__left__logo`}
                        onClick={handleLogoClick}
                    />
                </div>
                <div className="header-root__whatsapp">
                </div>
                <div className={`${className}__right`}>
                    <OptionsDropDown />
                </div>
            </div>
        );
    }

    const isWhatsappLocation = location.pathname.startsWith('/home/whatsapp');

    return (
        <header className="header-root">
            <div className="header-root__brand">
                <NavLink
                    to="/home"
                    className="header-root__brand-link">
                    <KaizIQText style={{height: '30px', width: 'max-content'}} className="header-root__logo" />
                </NavLink>
            </div>
            <div className="header-root__whatsapp">
                {isWhatsappLocation &&
                    <WhatsappHeader />
                }
            </div>
            <div className="header-root__actions">
                <OptionsDropDown />
            </div>
        </header>
    );
}

export default TopPanel;
